import { articleModuleQuery, useModule } from 'system/structure-modules';

export default function ArticleIndexScreen() {
    const { ArticleScreen } = useModule(articleModuleQuery);
    return <ArticleScreen />;
}
